<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header>
        <span class="breadcrumbs"><b-link :to="{name: `${collection}s`}">{{collection | capitalise | pluralise}}</b-link> / <b-link :to="{name: `${collection}`}">{{item ? item.name : ''}}</b-link> / Train</span>
        <!-- <b-button size="sm" variant="danger float-right" @click="delete_item">Delete</b-button> -->
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>
        <VoiceTraining :user='user' :profile='profile' :item="item"/>
      </div>
    </b-card>
  </b-container>
</template>

<script>
import VoiceTraining from "@/components/VoiceTraining.vue"
import { db, storage } from '@/main.js'

export default {
  metaInfo: {title: 'Clone train'},
  components: {VoiceTraining},
  props: ['user', 'profile'],
  firestore: function () {
    let item_id = this.$route.params.id

    return {
      item: db.collection(this.collection).doc(item_id)
    }
  },
  data() {
    return {
      collection: 'voice',
      item: undefined
    }
  }
}
</script>

<style>

</style>
